export abstract class HTTPError extends Error {
  public abstract unauthorized: boolean;
  public abstract message: string;
  public abstract status: number;
  public abstract type: 'DEFAULT_ERROR' | 'PROCESSING';
  public abstract response: Record<string, any>;
}
